//Table Results Fetching
export const ACTIVATE_MODAL = "ACTIVATE_MODAL";
export const ACTIVATE_LOADER = "ACTIVATE_LOADER";
export const IS_AUTH_SAGA = "IS_AUTH_SAGA";
export const IS_AUTH_REDUCER = "IS_AUTH_REDUCER";
